import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { CompletePetDetailsPetList } from './CompletePetDetailsPetList';

import styles from './CompletePetDetails.module.css';

const PetsAddedInPeriodSection = ({
  isPetDetailsComplete = () => false,
  onUpdatePetDemographics = () => { },
  pets = [],
}) => {
  const { t } = useTranslation('petDemos');
  const petCount = pets.length;

  if (petCount === 0) {
    return null;
  }

  return (
    <div className={styles.petsAddedSection}>
      <h3 className={styles.petsAddedSectionTitle}>
        <Trans
          components={{
            blue: <span className={styles.petsAddedCount} />,
          }}
          count={petCount}
          i18nKey="completeInformation.rolloverPetAdded"
          ns="petDemos"
          values={{ count: petCount }}
        />
      </h3>

      <p className={styles.petsAddedDescription}>
        {t('completeInformation.rolloverPetAddedDescription')}
      </p>

      <CompletePetDetailsPetList
        isPetDetailsComplete={isPetDetailsComplete}
        isRolloverCard={false}
        onUpdatePetDemographics={onUpdatePetDemographics}
        pets={pets}
      />
    </div>
  );
};

export { PetsAddedInPeriodSection };
